import { API, KitVersion } from "@thenounproject/lingo-core";
import { createQueryAction } from "@redux/actions/actionCreators";

type Args = {
  spaceId: number | string;
  kitId: string;
  version: number;
};

const [useKitVersion, fetchKitVersion] = createQueryAction<Args, KitVersion, string>(
  {
    entity: "kitVersions",
    action: "fetch",
  },
  async ({ args }) => {
    const res = await API.call<{ kitVersion: string }>({
      endpoint: `kits/${args.kitId}`,
      method: "GET",
      query: {
        v: args.version,
      },
    });
    return { ...res, result: res.result.kitVersion };
  }
);

export default useKitVersion;
export { fetchKitVersion };
